import { Component, OnInit, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'formly-field-date-range-2',
  template: `
    <div class="p-inputgroup" style="margin-top: 19px;">
      <span class="p-inputgroup-addon cursor-pointer">To</span>
      <p-calendar
        inputStyleClass="border-noround-left"
        #calendar
        [formControl]="formControl"
        [formlyAttributes]="field"
        [(ngModel)]="date"
        [minDate]="to.minDate"
        [maxDate]="to.maxDate"
        placeholder="Select date"
      >
      </p-calendar>
    </div>
    <div *ngIf="showError" class="formly-validation-message">
      <small class="p-error">{{ errorMessage }}</small>
    </div>
  `,
  styles: [
    `
      ::ng-deep .p-inputgroup-addon {
        background: #fff !important;
      }
      .formly-validation-message {
        color: #e24c4c;
        font-size: 13px;
        margin-top: 4px;
        font-weight: 500;
      }
    `,
  ],
})
export class FormlyFieldDateRangeComponent2
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  @ViewChild('calendar') calendar!: Calendar;
  date!: Date;
  dateTime = new Date();

  ngOnInit(): void {
    this.initializeDate();
  }

  private initializeDate() {
    if (this.formControl.value) {
      const dateValue = new Date(this.formControl.value);
      this.date = dateValue;
      this.formControl.setValue(dateValue);
    }
  }

  // Overriding as a getter
  override get showError(): boolean {
    return (
      this.formControl.invalid &&
      (this.formControl.dirty || this.formControl.touched)
    );
  }

  get errorMessage(): string | null {
    if (this.formControl.hasError('required')) {
      return `${this.to.label || 'This field'} is required`;
    }
    return null;
  }
}
